import { PipeTransform, Pipe } from "@angular/core";

@Pipe( {
    name: "fmtMetric",
    pure: true,
    standalone: false
} )
export class FormatMetricPipe implements PipeTransform {

    constructor() { }

    transform( value: string, metric: string, perUnit?: boolean ): any {

        if ( !value ) return "";
        if ( !metric ) return value;

        const trimmedVal = value.trim();
        if ( trimmedVal.length === 0 || (
            trimmedVal.length === 1 && isNaN(+trimmedVal))
        ) {
            return value;
        } else {
            return `${trimmedVal} ${ perUnit ? "/" : "" }${ metric.toLowerCase() }`;
        }
    }
}
